module.exports = __webpack_public_path__ + "img/visual-poetry.f421d49d.webp";